import React, { PureComponent } from 'react';

import ColumnalTextDisplay from 'components/ColumnalTextDisplay';

import Link from 'components/links/Unstyled/Internal';
import Button from 'components/deprecated/legacyElements/Button';
import styles from './style.module.scss';

export default class NotYourOrdinaryBrokerSection extends PureComponent {
  state = {
    shouldAnimateImages: false,
  };

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
    this.handleFrame();
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  scrollIsDirty = false;

  handleScroll = () => {
    this.scrollIsDirty = true;
  };

  handleFrame = () => {
    if (this.scrollIsDirty) {
      const scrollBottom =
        (window.pageYOffset || window.scrollY) + window.innerHeight;
      const revealThreshold = 0.7; // how much of element should be in viewport before animating
      const elementPosition =
        this.staticContainer.offsetTop +
        this.staticContainer.offsetHeight * revealThreshold;

      if (scrollBottom > elementPosition) {
        this.setState({ shouldAnimateImages: true });
        window.removeEventListener('scroll', this.handleScroll);
      }
      this.scrollIsDirty = false;
    }

    window.requestAnimationFrame(this.handleFrame);
  };

  render() {
    return (
      <section
        ref={(ref) => {
          this.staticContainer = ref;
        }}
        className={styles.notYourOrdinaryBrokerSection}
      >
        <div
          className={`inset-layout ${styles.notYourOrdinaryBrokerContainer}`}
        >
          <img
            alt=""
            loading="lazy"
            src={require('./assets/iPhone.png')}
            className={`${styles.iPhoneImage} ${
              this.state.shouldAnimateImages ? styles.animated : ''
            }`}
          />
          <ColumnalTextDisplay
            className={styles.columnTextContainer}
            title="Not your ordinary broker."
          >
            <p>
              Work with SquareFoot brokers who help you to get started with
              smart tools to handle every facet of your search, from negotiating
              a lease, to finding an interior designer.
            </p>
            <Link to="/profile/">
              <Button>Get Started</Button>
            </Link>
          </ColumnalTextDisplay>
          <img
            alt=""
            loading="lazy"
            src={require('./assets/laptop.png')}
            className={`${styles.laptopImage} ${
              this.state.shouldAnimateImages ? styles.animated : ''
            }`}
          />
        </div>
      </section>
    );
  }
}
